import { useEffect, useState } from 'react';
import './style.scss';
import { useHistory } from 'react-router-dom';
import {
  IProjectDocInfo,
  IProjectDocInfoMenu,
} from '../../../model/api-modules/document';
// import menuDown from '../../../assets/images/menu-down.png';
import { LeftMenuItem } from './left-menu-item';
import classNames from 'classnames';

interface IProps {
  readonly projectDocInfo: IProjectDocInfo | undefined;
  readonly selectActive: ReadonlyArray<number>;
  readonly isDocPublicRoute: boolean;
  readonly isShowHome: boolean;
}

export const LeftMenu = (props: IProps) => {
  const history = useHistory();
  const [isExpand, setIsExpand] = useState<Array<number>>([]);

  const handleScroll = () => {
    const sidebarInner = document.querySelector(
      '.sidebar-inner'
    ) as HTMLElement;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (sidebarInner) {
      if (scrollTop > 60) {
        sidebarInner.style.top = '48px';
      } else {
        sidebarInner.style.top = `${108 - scrollTop}px`;
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    getExpandList();
  }, [props.projectDocInfo, props.selectActive]);

  const findItemAndAncestors = (
    list: IProjectDocInfoMenu[],
    targetId: number,
    expand: number[]
  ): void => {
    const findAncestors = (
      nodes: IProjectDocInfoMenu[] | undefined
    ): boolean => {
      if (nodes) {
        for (const node of nodes) {
          if (node.id === targetId) {
            if (expand.indexOf(node.id) === -1) {
              expand.push(node.id);
            }
            return true;
          }
          if (
            node.nodes &&
            findAncestors(JSON.parse(JSON.stringify(node.nodes)))
          ) {
            if (expand.indexOf(node.id) === -1) {
              expand.push(node.id);
            }
            return true;
          }
        }
      }
      return false;
    };

    findAncestors(list);
  };

  const getExpandList = () => {
    const expand = isExpand;
    // const expand: number[] = [];
    if (props.selectActive.length !== 0 && props.projectDocInfo) {
      findItemAndAncestors(
        JSON.parse(JSON.stringify(props.projectDocInfo.menu)),
        props.selectActive[0],
        expand
      );
      // props.projectDocInfo?.menu.map((item) => {
      //   if (
      //     item.id === props.selectActive[0] &&
      //     expand.indexOf(item.id) === -1
      //   ) {
      //     expand.push(item.id);
      //   } else {
      //     const selectItem = item.nodes.filter(
      //       (it) => it.id === props.selectActive[0]
      //     );
      //     if (selectItem.length !== 0 && expand.indexOf(item.id) === -1) {
      //       expand.push(item.id);
      //     }
      //   }
      //   return expand;
      // });
      setIsExpand(expand);
    }
  };

  const joinPath = (
    projectId: string | number | undefined,
    docId?: string | number
  ) => {
    const url = props.isDocPublicRoute ? '/doc-public' : '/doc';
    if (!projectId) return;
    if (!props.isShowHome && !docId) return;
    if (docId) {
      history.push(`${url}/detail/${projectId}/${docId}`);
      return;
    }
    history.push(`${url}/detail/${projectId}`);
  };

  // const joinDocumentPath = (docInfo: IProjectDocInfoMenu) => {
  //   let linkInfo: IProjectDocInfoMenu;
  //   if (docInfo.content) {
  //     linkInfo = docInfo;
  //   } else {
  //     // 没内容的话，如果有子类，跳到子类的第一条数据
  //     if (Array.isArray(docInfo.nodes) && docInfo.nodes.length > 0) {
  //       // eslint-disable-next-line prefer-destructuring
  //       linkInfo = docInfo.nodes[0];
  //     } else {
  //       linkInfo = docInfo;
  //     }
  //   }
  //   joinPath(linkInfo.project_id, linkInfo.id);
  // };

  // const setExpand = (item: IProjectDocInfoMenu) => {
  //   if (item.nodes && item.nodes.length !== 0) {
  //     const expand = isExpand;
  //     if (isExpand.indexOf(item.id) !== -1) {
  //       expand.splice(isExpand.indexOf(item.id), 1);
  //       setIsExpand(expand);
  //     } else {
  //       expand.push(item.id);
  //       setIsExpand(expand);
  //     }
  //   }
  // };

  return (
    <div className="sidebar">
      <div className="sidebar-inner">
        {/* <div className="sidebox">
          <div id="sideHeader" className="side-header"></div>
        </div> */}
        <div className="side-scroll">
          <div
            onClick={() => joinPath(props?.projectDocInfo?.project_info.id)}
            className={classNames(
              'nav-text',
              !props.isShowHome ? 'disabled-side' : ''
            )}
          >
            {props?.projectDocInfo?.project_info &&
              props?.projectDocInfo?.project_info.name}
          </div>
          <ul id="sideNav" className="side-nav">
            {props?.projectDocInfo?.menu &&
              props?.projectDocInfo?.menu.map((item, index) => {
                return (
                  <LeftMenuItem
                    itemData={item}
                    selectActive={props.selectActive}
                    isExpand={isExpand}
                    setIsExpand={setIsExpand}
                    itemKey={`${index}`}
                    isDocPublicRoute={props.isDocPublicRoute}
                  />
                );
              })}
          </ul>
        </div>
      </div>
    </div>
  );
};
